import styled from 'styled-components';
import tw from 'twin.macro';

export default styled.div`
  ${tw`w-full h-full text-white flex flex-col min-h-screen py-16`}
  font-family: 'Avenir-Medium';
  font-weight: 500;
`;
